import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

import * as THREE from 'three';
import OBJLoader from 'three-obj-loader';
OBJLoader(THREE);

const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera( 30, window.innerWidth / window.innerHeight, 0.1, 1000 );

var light = new THREE.AmbientLight(0xffffff, 0.5);
scene.add(light);

var light = new THREE.PointLight(0xffffff, 0.5, 0, 2);
light.position.set( 0, 0, 15 );
scene.add(light);

camera.position.z = 6;

const renderer = new THREE.WebGLRenderer({
    antialias: true,
    alpha: true,
});
renderer.setSize( window.innerWidth, window.innerHeight );
// renderer.setPixelRatio(window.devicePixelRatio || 1)
document.body.appendChild( renderer.domElement );

var face;
var texture = new THREE.TextureLoader().load(`${process.env.PUBLIC_URL}/face3_color-1024.jpg`);
var material = new THREE.MeshStandardMaterial({
    map: texture,
    side: THREE.BackSide,
    roughness: 0.8,
    metalness: 0.1,
});

var loader = new THREE.BufferGeometryLoader();
loader.load(`${process.env.PUBLIC_URL}/new.json`, (geometry, materials) => {
    // var material = materials[ 0 ];
    console.log(material);
    material.map.anisotropy = renderer.capabilities.getMaxAnisotropy();
    // var material = new THREE.MeshLambertMaterial( { color: 0xF5F5F5 } );
    face = new THREE.Mesh( geometry, material );
    scene.add(face);
});

function onWindowResize() {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize( window.innerWidth, window.innerHeight );
}
window.addEventListener( 'resize', onWindowResize, false );

function animate() {
    requestAnimationFrame( animate );
    renderer.render( scene, camera );
    // if (face) face.rotation.x += 0.1;
    if (face) face.rotation.y = 11 * Math.sin(+new Date / 1500)
    // if (face) face.rotation.z = 0.02*Math.sin(+new Date / 5.7);
    // if (face) face.rotation.x = Math.PI; //  + 0.03*Math.sin(+new Date / 3.1);
}
animate();




// ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js